import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const GASOILPROVIDER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.GasOilProvider.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.GasOilProvider.SapCode')
    .required()
    .minLength(2)
    .maxLength(15)
    .build(),
  FieldBuilder
    .text('oldSapCode', 'Entity.GasOilProvider.OldSapCode')
    .maxLength(10)
    .build(),
];

export const GASOILPROVIDER_CONFIG = {
  entityName: 'GasOilProvider',
  localizationKey: 'General::Entity.GasOilProvider',
  fields: GASOILPROVIDER_FIELDS,
  permission: 'ControllingActivities.GasOilProviders',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
